import ServiceLocationCreateScreen from './ServiceLocationCreateScreen';

export default ServiceLocationCreateScreen;
